(function () {
  function addArrows(track) {
    var figure = track.closest('.product-card__figure');
    if (!figure) return;
    if (figure.querySelector('.ll-card-arrow')) return;
    if (track.querySelectorAll('img').length < 2) return;
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'll-card-arrow ll-card-arrow--prev';
    prev.setAttribute('aria-label', 'Immagine precedente');
    prev.textContent = '‹';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'll-card-arrow ll-card-arrow--next';
    next.setAttribute('aria-label', 'Immagine successiva');
    next.textContent = '›';
    figure.appendChild(prev);
    figure.appendChild(next);
  }
  function scan(root) {
    (root || document).querySelectorAll('.ll-card-track').forEach(addArrows);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ll-card-arrow') : null;
    if (!btn) return;
    e.preventDefault();
    var figure = btn.closest('.product-card__figure');
    var track = figure ? figure.querySelector('.ll-card-track') : null;
    if (!track) return;
    var dir = btn.classList.contains('ll-card-arrow--next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  });
  function init() { scan(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('ll-card-track')) { addArrows(n); }
          else if (n.querySelectorAll) { scan(n); }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ============================================================
   LES LULÚ — Riapertura delle preferenze cookie
   Il banner di Shopify sparisce dopo la scelta. Qui il link
   "Preferenze cookie" del footer riapre il pannello di Shopify,
   così chi cambia idea può rivedere il consenso in ogni momento.
   La parola "cookie" è la stessa in tutte le lingue pubblicate,
   quindi il riconoscimento del link funziona ovunque.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a, button') : null;
    if (!a) { return; }

    var href = a.getAttribute('href') || '';
    var placeholder = href === '' || href === '#' || href.indexOf('#preferenze-cookie') > -1 || href.indexOf('#cookie') > -1;
    if (!placeholder) { return; }
    if (!/cookie/i.test(a.textContent || '')) { return; }

    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.showPreferences !== 'function') { return; }

    e.preventDefault();
    cp.showPreferences();
  });
})();

/* ============================================================
   LES LULÚ — WISHLIST (preferiti)
   localStorage; salva anche titolo/prezzo/materiale/foto al momento
   dell'aggiunta, così la pagina Preferiti somiglia alla card di collezione.
   ============================================================ */
(function () {
  var KEY = "leslulu_wishlist";

  /* LES LULU: etichette dei preferiti nelle lingue del sito; la lingua arriva da <html lang>. */
  var WISH_I18N = {
    "it": { add: "Aggiungi ai preferiti", remove: "Rimuovi dai preferiti", page: "Preferiti", empty: "Non hai ancora preferiti. Tocca il cuore sui prodotti che ami per ritrovarli qui." },
    "en": { add: "Add to wishlist", remove: "Remove from wishlist", page: "Wishlist", empty: "Your wishlist is still empty. Tap the heart on the pieces you love to find them here." },
    "fr": { add: "Ajouter aux favoris", remove: "Retirer des favoris", page: "Favoris", empty: "Vos favoris sont encore vides. Touchez le cœur sur les bijoux que vous aimez pour les retrouver ici." },
    "es": { add: "Añadir a favoritos", remove: "Quitar de favoritos", page: "Favoritos", empty: "Tus favoritos aún están vacíos. Toca el corazón en las piezas que te gustan para encontrarlas aquí." },
    "de": { add: "Zu den Favoriten hinzufügen", remove: "Aus den Favoriten entfernen", page: "Favoriten", empty: "Ihre Favoriten sind noch leer. Tippen Sie auf das Herz bei den Stücken, die Ihnen gefallen, um sie hier wiederzufinden." },
    "pt-pt": { add: "Adicionar aos favoritos", remove: "Remover dos favoritos", page: "Favoritos", empty: "Os seus favoritos ainda estão vazios. Toque no coração nas peças que adora para as encontrar aqui." },
    "pl": { add: "Dodaj do ulubionych", remove: "Usuń z ulubionych", page: "Ulubione", empty: "Twoje ulubione są jeszcze puste. Dotknij serca przy biżuterii, która Ci się podoba, aby znaleźć ją tutaj." },
    "nl": { add: "Toevoegen aan verlanglijst", remove: "Verwijderen uit verlanglijst", page: "Verlanglijst", empty: "Je verlanglijst is nog leeg. Tik op het hartje bij de sieraden die je mooi vindt om ze hier terug te vinden." },
    "sv": { add: "Lägg till i önskelistan", remove: "Ta bort från önskelistan", page: "Önskelista", empty: "Din önskelista är fortfarande tom. Tryck på hjärtat på smyckena du gillar för att hitta dem här." },
    "da": { add: "Føj til ønskelisten", remove: "Fjern fra ønskelisten", page: "Ønskeliste", empty: "Din ønskeliste er stadig tom. Tryk på hjertet ved de smykker, du kan lide, for at finde dem her." },
    "nb": { add: "Legg til i ønskelisten", remove: "Fjern fra ønskelisten", page: "Ønskeliste", empty: "Ønskelisten din er fortsatt tom. Trykk på hjertet på smykkene du liker for å finne dem her." },
    "ro": { add: "Adaugă la favorite", remove: "Elimină de la favorite", page: "Favorite", empty: "Favoritele tale sunt încă goale. Atinge inima pe bijuteriile care îți plac pentru a le regăsi aici." },
    "cs": { add: "Přidat k oblíbeným", remove: "Odebrat z oblíbených", page: "Oblíbené", empty: "Vaše oblíbené jsou zatím prázdné. Klepněte na srdce u šperků, které se vám líbí, a najdete je zde." },
    "el": { add: "Προσθήκη στα αγαπημένα", remove: "Αφαίρεση από τα αγαπημένα", page: "Αγαπημένα", empty: "Τα αγαπημένα σας είναι ακόμη άδεια. Πατήστε την καρδιά στα κοσμήματα που αγαπάτε για να τα βρείτε εδώ." },
    "hu": { add: "Hozzáadás a kedvencekhez", remove: "Eltávolítás a kedvencek közül", page: "Kedvencek", empty: "A kedvencei még üresek. Érintse meg a szívet a kedvelt ékszereken, hogy itt megtalálja őket." },
    "fi": { add: "Lisää suosikkeihin", remove: "Poista suosikeista", page: "Suosikit", empty: "Suosikkisi ovat vielä tyhjät. Napauta sydäntä pitämiesi korujen kohdalla, niin löydät ne täältä." }
  };
  function wishDict() {
    var l = (document.documentElement.getAttribute("lang") || "it").toLowerCase();
    if (WISH_I18N[l]) { return WISH_I18N[l]; }
    var base = l.split("-")[0];
    if (base === "pt") { return WISH_I18N["pt-pt"]; }
    if (WISH_I18N[base]) { return WISH_I18N[base]; }
    return WISH_I18N["it"];
  }
  function wishT(k) { var d = wishDict(); return d[k] || WISH_I18N["it"][k]; }
  function wishAttr(v) { return (v || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"); }
  var HEART = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' aria-hidden='true' focusable='false'><path d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'/></svg>";

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function entryHandle(e) { return (typeof e === "string") ? e : (e && e.h); }
  function indexOfHandle(list, h) {
    for (var i = 0; i < list.length; i++) { if (entryHandle(list[i]) === h) { return i; } }
    return -1;
  }
  function has(h) { return indexOfHandle(read(), h) !== -1; }
  function toggle(h, data) {
    var l = read();
    var i = indexOfHandle(l, h);
    if (i === -1) {
      var obj = { h: h };
      if (data) {
        if (data.t) { obj.t = data.t; }
        if (data.p) { obj.p = data.p; }
        if (data.m) { obj.m = data.m; }
        if (data.img) { obj.img = data.img; }
        if (data.u) { obj.u = data.u; }
      }
      l.push(obj);
    } else {
      l.splice(i, 1);
    }
    write(l);
    return l;
  }
  function count() { return read().length; }

  function esc(s) { return (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\\"/g, "&quot;"); }

  function money(cents) {
    try { return "€" + (cents / 100).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return "€" + (cents / 100).toFixed(2); }
  }

  function priceFrom(scope) {
    if (!scope) { return ""; }
    var sp = scope.querySelector("price-list sale-price") || scope.querySelector(".price-list sale-price") || scope.querySelector("price-list") || scope.querySelector(".price-list");
    if (!sp) { return ""; }
    var c = sp.cloneNode(true);
    var srs = c.querySelectorAll(".sr-only");
    for (var i = 0; i < srs.length; i++) { srs[i].parentNode.removeChild(srs[i]); }
    return c.textContent.replace(/\\s+/g, " ").trim();
  }
  function dataFromCard(card) {
    var titleA = card.querySelector(".product-card__title a") || card.querySelector(".product-card__title");
    var matEl = card.querySelector(".leslulu-card-material");
    var imgEl = card.querySelector("img");
    var linkEl = card.querySelector('a[href*="/products/"]');
    return {
      t: titleA ? titleA.textContent.replace(/\\s+/g, " ").trim() : "",
      p: priceFrom(card.querySelector(".product-card__info")) || priceFrom(card),
      m: matEl ? matEl.textContent.replace(/\\s+/g, " ").trim() : "",
      img: imgEl ? (imgEl.currentSrc || imgEl.getAttribute("src") || "") : "",
      u: linkEl ? linkEl.getAttribute("href") : ("/products/" + (card.getAttribute("handle") || ""))
    };
  }
  function dataFromPdp() {
    var sec = document.querySelector(".shopify-section--main-product") || document;
    var titleEl = sec.querySelector(".product-info__title");
    var imgEl = sec.querySelector(".product-gallery img") || sec.querySelector("img");
    return {
      t: titleEl ? titleEl.textContent.replace(/\\s+/g, " ").trim() : "",
      p: priceFrom(sec.querySelector(".product-info")) || priceFrom(sec),
      m: "",
      img: imgEl ? (imgEl.currentSrc || imgEl.getAttribute("src") || "") : "",
      u: location.pathname
    };
  }

  function makeBtn(handle, variant) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "ll-wish-btn ll-wish-btn--" + variant;
    b.setAttribute("data-ll-wish", handle);
    b.setAttribute("aria-label", has(handle) ? wishT("remove") : wishT("add"));
    b.setAttribute("aria-pressed", has(handle) ? "true" : "false");
    if (has(handle)) { b.classList.add("is-active"); }
    b.innerHTML = HEART;
    return b;
  }

  function injectCards(root) {
    (root || document).querySelectorAll("product-card[handle]").forEach(function (card) {
      if (card.querySelector(".ll-wish-btn--card")) { return; }
      var handle = card.getAttribute("handle");
      if (!handle) { return; }
      var btn = makeBtn(handle, "card");
      btn.classList.add("ll-wish-btn--oninfo");
      card.appendChild(btn);
    });
  }

  function handleFromPath() {
    var path = location.pathname || "";
    var idx = path.indexOf("/products/");
    if (idx === -1) { return null; }
    var rest = path.slice(idx + 10);
    rest = rest.split("/")[0].split("?")[0].split("#")[0];
    if (!rest) { return null; }
    try { return decodeURIComponent(rest); } catch (e) { return rest; }
  }

  function injectPdp() {
    if (!document.querySelector(".shopify-section--main-product")) { return; }
    var title = document.querySelector(".shopify-section--main-product .product-info__title");
    var wrap = title ? title.closest(".product-info__block-item") : null;
    if (!wrap || wrap.querySelector(".ll-wish-btn--pdp")) { return; }
    var handle = handleFromPath();
    if (!handle) { return; }
    wrap.classList.add("ll-wish-anchor");
    wrap.appendChild(makeBtn(handle, "pdp"));
  }

  function injectHeader() {
    var list = document.querySelector(".header__secondary-nav .header__icon-list");
    if (!list || list.querySelector(".ll-wish-header")) { return; }
    var li = document.createElement("li");
    var a = document.createElement("a");
    a.href = "/pages/preferiti";
    a.className = "relative block tap-area ll-wish-header";
    a.setAttribute("aria-label", wishT("page"));
    a.innerHTML = HEART + "<div class='header__cart-count'><span class='count-bubble ll-wish-count" + (count() === 0 ? " opacity-0" : "") + "'><span aria-hidden='true'>" + count() + "</span></span></div>";
    li.appendChild(a);
    var cart = list.querySelector("li:last-child");
    if (cart) { list.insertBefore(li, cart); } else { list.appendChild(li); }
  }

  function injectMobileBar() {
    var icons = document.querySelector("#leslulu-mobile-bar .leslulu-mbar__icons");
    if (!icons || icons.querySelector(".leslulu-mbar__wish")) { return; }
    var a = document.createElement("a");
    a.href = "/pages/preferiti";
    a.className = "leslulu-mbar__ic leslulu-mbar__wish";
    a.setAttribute("aria-label", wishT("page"));
    a.style.position = "relative";
    a.innerHTML = HEART + "<span class='leslulu-mbar__count ll-wish-count" + (count() === 0 ? " opacity-0" : "") + "'><span aria-hidden='true'>" + count() + "</span></span>";
    var svg = a.querySelector("svg");
    if (svg) { svg.setAttribute("width", "22"); svg.setAttribute("height", "22"); }
    var cart = icons.querySelector(".leslulu-mbar__cart");
    if (cart) { icons.insertBefore(a, cart); } else { icons.appendChild(a); }
  }

  function refreshButtons() {
    document.querySelectorAll(".ll-wish-btn").forEach(function (b) {
      var on = has(b.getAttribute("data-ll-wish"));
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
      b.setAttribute("aria-label", on ? wishT("remove") : wishT("add"));
    });
  }
  function refreshCount() {
    var c = count();
    document.querySelectorAll(".ll-wish-count").forEach(function (el) {
      el.classList.toggle("opacity-0", c === 0);
      var n = el.querySelector("span"); if (n) { n.textContent = c; }
    });
  }

  function buildItem(e) {
    var el = document.createElement("div");
    el.className = "ll-wish-item";
    var img = e.img || "";
    if (img && img.indexOf("//") === 0) { img = "https:" + img; }
    var url = e.u || ("/products/" + e.h);
    var t = esc(e.t || "");
    var mat = e.m ? ("<p class='ll-wish-item__material'>" + esc(e.m) + "</p>") : "";
    var price = e.p ? esc(e.p) : "";
    el.innerHTML =
      "<a class='ll-wish-item__media' href='" + url + "'>" + (img ? ("<img src='" + img + "' alt='" + t + "' loading='lazy'>") : "") + "</a>" +
      "<div class='ll-wish-item__info'>" +
        "<a class='ll-wish-item__title' href='" + url + "'>" + t + "</a>" +
        mat +
        "<p class='ll-wish-item__price'>" + price + "</p>" +
      "</div>" +
      "<button type='button' class='ll-wish-btn ll-wish-btn--card ll-wish-remove ll-wish-btn--oninfo is-active' data-ll-wish='" + e.h + "' aria-label='" + wishAttr(wishT("remove")) + "'>" + HEART + "</button>";
    return el;
  }

  function pageRoot() { return document.getElementById("leslulu-wishlist-page") || document.querySelector("[data-ll-wishlist]"); }

  function renderPage() {
    var root = pageRoot();
    if (!root) { return; }
    var list = read();
    if (!list.length) {
      root.innerHTML = "<p class='ll-wish-empty'>" + wishAttr(wishT("empty")) + "</p>";
      return;
    }
    root.innerHTML = "<div class='ll-wish-grid'></div>";
    var grid = root.querySelector(".ll-wish-grid");
    list.forEach(function (entry) {
      var e = (typeof entry === "string") ? { h: entry } : (entry || {});
      if (!e.h) { return; }
      if (e.t && e.p && e.img) {
        grid.appendChild(buildItem(e));
      } else {
        fetch("/products/" + encodeURIComponent(e.h) + ".js", { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p) {
              grid.appendChild(buildItem({ h: e.h, t: e.t || p.title, p: e.p || money(p.price), m: e.m || "", img: e.img || p.featured_image, u: e.u || ("/products/" + e.h) }));
            }
          })
          .catch(function () {});
      }
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(".ll-wish-btn") : null;
    if (!btn) { return; }
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute("data-ll-wish");
    if (!handle) { return; }
    var data = null;
    if (!has(handle)) {
      var card = btn.closest("product-card[handle]");
      if (card) { data = dataFromCard(card); }
      else if (btn.classList.contains("ll-wish-btn--pdp")) { data = dataFromPdp(); }
    }
    toggle(handle, data);
    refreshButtons();
    refreshCount();
    if (btn.classList.contains("ll-wish-remove")) {
      var item = btn.closest(".ll-wish-item");
      if (item && item.parentNode) { item.parentNode.removeChild(item); }
      if (!read().length) { renderPage(); }
    }
  }, true);

  function init() {
    injectCards(document);
    injectHeader();
    injectMobileBar();
    injectPdp();
    refreshButtons();
    refreshCount();
    renderPage();
  }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
  else { init(); }

  if (window.MutationObserver) {
    var obs = new MutationObserver(function (muts) {
      var scan = false;
      for (var i = 0; i < muts.length; i++) {
        var ns = muts[i].addedNodes;
        for (var j = 0; j < ns.length; j++) { if (ns[j].nodeType === 1) { scan = true; } }
      }
      if (scan) { injectCards(document); injectHeader(); injectMobileBar(); refreshButtons(); refreshCount(); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();